// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2vUQG","requiredAsterisk":"Info_requiredAsterisk__2isu-"};